import type { InputRadioProps } from '@presentation/components/InputRadio/types';

export interface InputRadioFieldProps<TValue> extends InputRadioProps<TValue> {
  name: string;
}
